import React from "react";
import { Redirect } from "react-router-dom";

import { useIsRouteEnabled } from "components/navigation/hooks/useIsRouteEnabled";
import { deriveRedirectTarget, GENERAL_SETTINGS_ROUTE } from "components/router/Routes";

export const GeneralSettingsView = () => {
    const isRouteEnabled = useIsRouteEnabled();

    const target = deriveRedirectTarget(GENERAL_SETTINGS_ROUTE, isRouteEnabled);

    return <Redirect to={target.path} />;
};
